import { Link } from 'react-router-dom'
import BrandLogo from './BrandLogo'

interface LegalPageLayoutProps {
  title: string
  lastUpdated: string
  children: React.ReactNode
}

export default function LegalPageLayout({ title, lastUpdated, children }: LegalPageLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <BrandLogo showTagline={false} size="md" linkToHome />
            <Link to="/" className="text-gray-600 hover:text-primary-600">
              ← Back to Home
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">{title}</h1>
          <p className="text-sm text-gray-500 mb-8">Last Updated: {lastUpdated}</p>
          
          <div className="prose prose-lg max-w-none">
            {children}
          </div>

          {/* Print and Back */}
          <div className="mt-12 pt-8 border-t border-gray-200 flex justify-between items-center">
            <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium">
              ← Back to Home
            </Link>
            <button 
              onClick={() => window.print()} 
              className="text-gray-600 hover:text-gray-700 font-medium"
            >
              🖨 Print
            </button>
          </div>
        </div>

        {/* Legal Notice */}
        <div className="mt-8 text-center text-sm text-gray-500">
          <p>This document should be reviewed by a qualified legal professional.</p>
          <p>For questions, please contact: legal@loanloop.com.au</p>
        </div>
      </div>
    </div>
  )
}
